import "./Billing.css";
import { useState, useContext, useEffect } from "react";
import {
    FaCircle,
    FaPrint,
    FaFilePdf,
    FaPhoneSquareAlt,
    FaTrash,
} from "react-icons/fa";
import { LiaAngleDoubleRightSolid } from "react-icons/lia";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { IoIosContact } from "react-icons/io";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import Form from "react-bootstrap/Form";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { Container, Row, Col, Alert } from "react-bootstrap";
import Customerdetails from "../components/Customerdetails";
import dropdownData from "../data/dropdownData.json";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { AuthContext } from "../context/AuthContext";
import { getOrders, updateOrder, createOders, deleteOders } from "../api";
import { getItems, updateItems, createItems, deleteItems } from "../api";
import { getCustomers, getCategories } from "../api";
import { useNavigate } from "react-router-dom";


// Mock data (replace with props or API in production)

const ReceivedModes = ["Cash", "Gpay", "Credit"];
const paidModes = ["-", "HDFC", "Indian Bank", "Paynearby", "Credit Card"];
const cdetails = [
    { cphone: '8903035247', cname: 'vijay', cid: 1 },
    { cphone: '9842743646', cname: 'deva', cid: 1 },
    { cphone: '9095820822', cname: 'santhi', cid: 1 },
];

export default function NewOrderPage() {
    const navigate = useNavigate();
    const [categories, setCategories] = useState(dropdownData.category);
    const { user } = useContext(AuthContext);
    const [customers, setCustomers] = useState(dropdownData.customers);
    const [iscredit, setIsCredit] = useState(true);
    const handleSwitchChange = (event) => {
        setIsCredit(event.target.checked);
    };
    const [order, setOrder] = useState({
        id: "-1",
        customer_id: "",
        notes: "",
        cash_received: 0,
        cash_received_through: ReceivedModes[0],
        cash_paid: 0,
        cash_paid_through: paidModes[0],
        balance: 0,
        date: new Date().toISOString().slice(0, 10).toString(),
        time: new Date().toTimeString().slice(0, 8)
    });

    const [items, setItems] = useState([
        { order_id: -1, category_id: categories[0].id, qty: 1, price: 0 },
    ]);

    var selectedCustomer = customers.find((c) => c.id === order.customer_id);

    const handleItemChange = (index, field, value) => {
        const updatedItems = [...items];
        updatedItems[index][field] = field === "category_id" ? parseInt(value) : parseFloat(value);
        setItems(updatedItems);
    };

    const addItem = () => {
        setItems([...items, { category_id: categories[0].id, qty: 1, price: 0 }]);
    };

    const deleteItem = (indexToDelete) => {
        setItems(items.filter((_, index) => index !== indexToDelete));
    };

    const getItemTotal = (item) => item.qty * item.price;

    const subTotal = items?.reduce((sum, item) => sum + getItemTotal(item), 0);
    const discountAmt = (subTotal * 0) / 100;
    const totalAmount = subTotal - discountAmt;
    const balance = totalAmount - order.cash_received;

    const handleAmountChange = (field, value) => {
        setOrder((prev) => ({
            ...prev,
            [field]: field === "cash_received" ? parseFloat(value) || 0 : value,
        }));
    };

    const printInvoice = () => {
        window.print();
    };
    const handleCustomerChange = (id, name, number) => {
        if (id === -1) {
            setCustomers((prev) => [...prev, { id: -1, phone: number, name }]);
            setOrder((prev) => ({
                ...prev,
                customer_id: -1,
            }));
        }
        else {
            setOrder((prev) => ({
                ...prev,
                customer_id: id,
            }));
        }

    };
    const handleOnSubmit = () => {
        const modifiedOrder = {
            ...order,
            balance: balance,
        }

        createOders(modifiedOrder).then((response) => {
            console.log("Order created successfully", response.data);
            setOrder(response.data);
            const orderId = response.data.id;
            const itemsWithOrderId = items.map(item => ({ ...item, order_id: orderId }));
            createItems(itemsWithOrderId).then((response) => {
                alert("ordered entered successfully");
                navigate('/');
                console.log("Items created successfully", response.data);
                // setItems(response.data);
            }).catch((error) => {
                console.error("Error creating items:", error);
            });
        }
        ).catch((error) => {
            alert("Error creating order: " + error.response.data.error);
            console.error("Error creating order:", error);
        });
        // console.log(customers)
        // console.log(items)
        // console.log(order)
    }
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getCustomers()
            .then((res) => {
                setCustomers(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching customers:', err);
                setLoading(false);
            });
        getCategories()
            .then((res) => {
                setCategories(res.data);
                setLoading(false);
            }
            )
            .catch((err) => {
                alert('Error fetching categories:', err);
                console.error('Error fetching categories:', err);
                setLoading(false);
            }
            );
    }, []);

    if (loading) return <p>Loading...</p>;

    return (
        <Container className="mt-4">
            {!user ? (
                <div>
                    <h2 className="text-center mb-4 text-danger">Please Login..</h2>
                </div>
            ) : (
                <div className="page-content container">
                    <div className="page-header text-blue-d2 d-flex justify-content-between align-items-center">
                        <h1 className="page-title text-secondary-d1">
                            Invoice
                            <small className="page-info">
                                <LiaAngleDoubleRightSolid />
                                ID: #{order.id}
                            </small>
                        </h1>
                        <div className="page-tools">
                            <div className="action-buttons">
                                <button className="btn bg-white btn-light mx-1 text-95" onClick={printInvoice}>
                                    <FaPrint className="mr-1 text-primary-m1 text-120 w-2" />
                                    Print
                                </button>
                                {/* <button className="btn bg-white btn-light mx-1 text-95">
                            <FaFilePdf className="mr-1 text-danger-m1 w-2" />
                            Export
                        </button> */}
                            </div>
                        </div>
                    </div>

                    <div className="container px-0">
                        <div className="row mt-4">
                            <div className="col-12">
                                <Row className="brc-default-l1 mx-n1 mb-4">
                                    <hr className="w-100" />
                                </Row>

                                <Row>
                                    <Col sm={6}>
                                        <div>

                                            <Customerdetails invalue={selectedCustomer} cdetails={customers} handleCustomerChange={handleCustomerChange} />
                                            {/* <TextField
                                        style={{ marginTop: 5 }} disabled
                                        id="outlined-basic"
                                        label="Customer Name"
                                        variant="outlined" value={selectedCustomer?.name}
                                        // slotProps={{
                                        //     input: {
                                        //         startAdornment: (
                                        //             <InputAdornment position="start">
                                        //                 <IoIosContact size={25} className="align-middle" />
                                        //             </InputAdornment>
                                        //         ),
                                        //     },
                                        // }} 
                                        /> */}
                                            {/* <IoIosContact size={25} className="align-middle" /> */}
                                            <br />
                                            <span >Customer Name :   </span>
                                            <span className="text-600 text-110 text-blue align-middle">
                                                {selectedCustomer?.name}
                                            </span>
                                        </div>
                                        <div className="text-grey-m2">
                                            {/* <div className="my-1">
                                        <FaPhoneSquareAlt size={23} />{" "}
                                        <b className="text-600"> {selectedCustomer?.phone}</b>
                                    </div> */}
                                            <div className="my-1">
                                                Credit <Switch checked={iscredit} onChange={handleSwitchChange} /> Cash
                                            </div>
                                        </div>
                                    </Col>
                                    <Col sm={6} className="d-flex justify-content-end">
                                        <div className="text-grey-m2">
                                            <div className="mt-1 mb-2 text-secondary-m1 text-600 text-125">Invoice</div>
                                            <div className="my-2">
                                                <FaCircle className="text-blue-m2 text-xs mr-1" />{" "}
                                                <span className="text-600 text-90">ID:</span> #{order.id}
                                            </div>
                                            <div className="my-2">
                                                <FaCircle className="text-blue-m2 text-xs mr-1" />{" "}
                                                <span className="text-600 text-90">Issue Date:</span> {order.date}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Items Header */}
                                <div className="mt-4">
                                    <div className="row bgc-default-tp1 py-2 text-white text-600">
                                        <div className="d-none d-sm-block col-1">#</div>
                                        <div className="col-3">Description</div>
                                        <div className="d-none d-sm-block col-2">Qty</div>
                                        <div className="d-none d-sm-block col-2">Unit Price</div>
                                        <div className="col-3">Amount</div>
                                        <div className="col-1 text-center">Del</div>
                                    </div>

                                    {/* Item Rows */}
                                    <div className="text-95 text-secondary-d3">
                                        {items.map((item, index) => (
                                            <div key={index} className="row py-2 align-items-center">
                                                <div className="d-none d-sm-block col-1">{index + 1}</div>

                                                <div className="col-3" >
                                                    <Autocomplete
                                                        disablePortal
                                                        options={categories}
                                                        onChange={(event, newValue) => {
                                                            console.log("Selected category object:", newValue);
                                                            handleItemChange(index, "category_id", newValue?.id);
                                                        }}
                                                        name="itemCategory"
                                                        // sx={{ width: 250, height: "50px" }}
                                                        renderInput={(params) => <TextField {...params} label="Categories" />}
                                                    />
                                                    {/* <Form.Select
                                                size="sm"
                                                value={item.category_id}
                                                onChange={(e) => handleItemChange(index, "category_id", e.target.value)}
                                            >
                                                {categories.map((cat) => (
                                                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                                                ))}
                                            </Form.Select> */}
                                                </div>

                                                <div className="d-none d-sm-block col-2">
                                                    <TextField
                                                        size="small"
                                                        type="number"
                                                        value={item.qty}
                                                        onChange={(e) => handleItemChange(index, "qty", e.target.value)}
                                                    />
                                                </div>

                                                <div className="d-none d-sm-block col-2">
                                                    <FormControl fullWidth>
                                                        <OutlinedInput
                                                            size="small"
                                                            type="number"
                                                            value={item.price}
                                                            onChange={(e) => handleItemChange(index, "price", e.target.value)}
                                                            startAdornment={<InputAdornment position="start"><FaIndianRupeeSign /></InputAdornment>}
                                                        />
                                                    </FormControl>
                                                </div>

                                                <div className="col-3">
                                                    <OutlinedInput
                                                        size="small"
                                                        value={getItemTotal(item)}
                                                        startAdornment={<InputAdornment position="start"><FaIndianRupeeSign /></InputAdornment>}
                                                        disabled
                                                    />
                                                </div>

                                                <div className="col-1 text-center">
                                                    <Button variant="text" size="small" onClick={() => deleteItem(index)}>
                                                        <FaTrash color="red" />
                                                    </Button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <Button variant="outlined" className="my-3" onClick={addItem}>+ Add Item</Button>

                                    {/* Notes and Summary */}
                                    <div className="row mt-3">
                                        <div className="col-lg-4">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Notes</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={5}
                                                    value={order.notes}
                                                    onChange={(e) =>
                                                        setOrder((prevOrder) => ({
                                                            ...prevOrder,
                                                            notes: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </Form.Group>
                                        </div>

                                        <div className="col-lg-4 col-sm-5 text-grey">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Amount Paid</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={order.cash_paid}
                                                    onChange={(e) => handleAmountChange("cash_paid", e.target.value)}
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Paid Mode</Form.Label>
                                                <Form.Select
                                                    value={order.cash_paid_through}
                                                    onChange={(e) => handleAmountChange("cash_paid_through", e.target.value)}
                                                >
                                                    {paidModes.map((mode, i) => (
                                                        <option key={i} value={mode}>{mode}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-4 col-sm-5 text-grey">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Amount Received</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={order.cash_received}
                                                    onChange={(e) => handleAmountChange("cash_received", e.target.value)}
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Received Mode</Form.Label>
                                                <Form.Select
                                                    value={order.cash_received_through}
                                                    onChange={(e) => handleAmountChange("cash_received_through", e.target.value)}
                                                >
                                                    {ReceivedModes.map((mode, i) => (
                                                        <option key={i} value={mode}>{mode}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                            <div style={{ fontSize: 20 }}>
                                                <span >Total Amount: <FaIndianRupeeSign /><strong>{totalAmount.toFixed(2)}</strong> | Balance: <FaIndianRupeeSign /><strong>{balance.toFixed(2)}</strong></span>
                                            </div>
                                        </div>

                                    </div>

                                    <hr />
                                    <div className="float-lg-right">
                                        <Button variant="contained" onClick={handleOnSubmit}>Submit </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)}
        </Container>
    );
}
